// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3N2ZD","image":"Header_image__13FnJ","name":"Header_name__aFG8Q","info":"Header_info__ChM_Q","infoRow":"Header_infoRow__3sz86"};